<template>
  <div>
    <b-row>
      <b-col>
        <b-card no-body>
          <b-card-header>
            <b-card-title>Font stacks</b-card-title>
          </b-card-header>
          <b-card-body class="pb-1">
            <b-card-text>
              We use sans serif fonts for most of our type in-product, the exception being when you want to display code the you should defer to monospace fonts.
            </b-card-text>
          </b-card-body>

          <b-card-header>
            <b-card-title>Sans serif</b-card-title>
          </b-card-header>
          <b-card-body class="pb-1">
            <b-table-simple
              hover
              caption
              responsive
            >
              <b-thead>
                <b-th>Language</b-th>
                <b-th>Font family</b-th>
                <b-th>Code</b-th>
              </b-thead>
              <b-tbody>
                <b-tr>
                  <b-td>EN, BM</b-td>
                  <b-td>
                    <p class="m-0">
                      Lato<br>Good vibes
                    </p>
                  </b-td>
                  <b-td>
                    <code>
                      <span>
                        font-family: 'Lato', Helvetica, Arial, serif !default;
                      </span>
                    </code>
                    <br>
                    <code>
                      <span>
                        font-family: N/A
                      </span>
                    </code>
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-td>CN</b-td>
                  <b-td>
                    <p class="m-0 heiti-font">
                      黑体
                    </p>
                  </b-td>
                  <b-td>
                    <code>
                      <span>
                        font-family: 'adobe-heiti-std', sans-serif;
                      </span>
                    </code>
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-td>TH</b-td>
                  <b-td>
                    <p class="m-0 sarabun-font">
                      Sarabun
                    </p>
                  </b-td>
                  <b-td>
                    <code>
                      <span>
                        font-family: 'Sarabun', sans-serif;
                      </span>
                    </code>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-card-body>

          <b-card-header>
            <b-card-title>Monospaced</b-card-title>
          </b-card-header>
          <b-card-body class="pb-1">
            <b-table-simple
              hover
              caption
              responsive
            >
              <b-thead>
                <b-th>Language</b-th>
                <b-th>Font family</b-th>
                <b-th>Code</b-th>
              </b-thead>
              <b-tbody>
                <b-tr>
                  <b-td>EN, BM, CN, TH</b-td>
                  <b-td>
                    <p class="m-0 droid-font">
                      Droid Sans
                    </p>
                  </b-td>
                  <b-td>
                    <code>
                      <span>
                        font-family: 'Droid Sans', Helvetica, Arial, serif !default;
                      </span>
                    </code>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-card-body>

          <b-card-header>
            <b-card-title>Usage</b-card-title>
          </b-card-header>
          <b-card-body>
            <b-card-text>
              Keeping typography consistent and sticking to logical hierarchies ensures that elements in the UI are clear and easily recognizable when scanning the page. Text sizes, styles, and layouts were selected to balance content and UI and to foster familiarity.
            </b-card-text>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-card no-body>
          <b-card-header>
            <b-card-title>Styles</b-card-title>
          </b-card-header>
          <b-card-body class="pb-1">
            <b-table-simple
              hover
              caption
              responsive
            >
              <b-thead>
                <b-th>Style</b-th>
                <b-th>Static page properties</b-th>
                <b-th>Dashboard page Properties</b-th>
              </b-thead>
              <b-tbody>
                <b-tr>
                  <b-td><h1>h1</h1></b-td>
                  <b-td>
                    <div class="pb-2">
                      <strong>Basic properties</strong><br>
                      Font-size: 56px / 2rem<br>
                      Font-weight: 400 / regular
                    </div>
                    <div class="pb-2">
                      <strong>UI properties</strong><br>
                      Line height: 33.6px / 1.2<br>
                      Margin bottom: 7px / 0.5rem
                    </div>
                    <div>
                      <strong>Use for</strong><br>
                      Main titles, use only once per page.
                    </div>
                  </b-td>
                  <b-td>
                    <div class="pb-2">
                      <strong>Basic properties</strong><br>
                      Font-size: 28px<br>
                      Font-weight: 400 / regular
                    </div>
                    <div class="pb-2">
                      <strong>UI properties</strong><br>
                      Line height: 32px<br>
                      Margin bottom: 8px
                    </div>
                    <div>
                      <strong>Use for</strong><br>
                      Main titles, use only once per page.
                    </div>
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-td><h2>h2</h2></b-td>
                  <b-td>
                    <div class="pb-2">
                      <strong>Basic properties</strong><br>
                      Font-size: 24px / 1.714rem<br>
                      Font-weight: 400 / regular
                    </div>
                    <div class="pb-2">
                      <strong>UI properties</strong><br>
                      Line height: 28.8px / 1.2<br>
                      Margin bottom: 7px / 0.5rem
                    </div>
                    <div>
                      <strong>Use for</strong><br>
                      Main titles, use only once per page.
                    </div>
                  </b-td>
                  <b-td>
                    <div class="pb-2">
                      <strong>Basic properties</strong><br>
                      Font-size: 24px<br>
                      Font-weight: 400 / regular
                    </div>
                    <div class="pb-2">
                      <strong>UI properties</strong><br>
                      Line height: 28px<br>
                      Margin bottom: 8px
                    </div>
                    <div>
                      <strong>Use for</strong><br>
                      Main titles, use only once per page.
                    </div>
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-td><h3>h3</h3></b-td>
                  <b-td>
                    <div class="pb-2">
                      <strong>Basic properties</strong><br>
                      Font-size: 21px / 1.5rem<br>
                      Font-weight: 400 / regular
                    </div>
                    <div class="pb-2">
                      <strong>UI properties</strong><br>
                      Line height: 25.2px / 1.2<br>
                      Margin bottom: 7px / 0.5rem
                    </div>
                    <div>
                      <strong>Use for</strong><br>
                      Main titles, use only once per page.
                    </div>
                  </b-td>
                  <b-td>
                    <div class="pb-2">
                      <strong>Basic properties</strong><br>
                      Font-size: 20px<br>
                      Font-weight: 400 / regular
                    </div>
                    <div class="pb-2">
                      <strong>UI properties</strong><br>
                      Line height: 24px<br>
                      Margin bottom: 8px
                    </div>
                    <div>
                      <strong>Use for</strong><br>
                      Main titles, use only once per page.
                    </div>
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-td><h4>h4</h4></b-td>
                  <b-td>
                    <div class="pb-2">
                      <strong>Basic properties</strong><br>
                      Font-size: 18px / 1.286rem<br>
                      Font-weight: 400 / regular
                    </div>
                    <div class="pb-2">
                      <strong>UI properties</strong><br>
                      Line height: 21.6px / 1.2<br>
                      Margin bottom: 7px / 0.5rem
                    </div>
                    <div>
                      <strong>Use for</strong><br>
                      Main titles, use only once per page.
                    </div>
                  </b-td>
                  <b-td>
                    <div class="pb-2">
                      <strong>Basic properties</strong><br>
                      Font-size: 18px<br>
                      Font-weight: 400 / regular
                    </div>
                    <div class="pb-2">
                      <strong>UI properties</strong><br>
                      Line height: 20px<br>
                      Margin bottom: 8px
                    </div>
                    <div>
                      <strong>Use for</strong><br>
                      Main titles, use only once per page.
                    </div>
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-td><h5>h5</h5></b-td>
                  <b-td>
                    <div class="pb-2">
                      <strong>Basic properties</strong><br>
                      Font-size: 15px / 1.07rem<br>
                      Font-weight: 400 / regular
                    </div>
                    <div class="pb-2">
                      <strong>UI properties</strong><br>
                      Line height: 18px / 1.2<br>
                      Margin bottom: 7px / 0.5rem
                    </div>
                    <div>
                      <strong>Use for</strong><br>
                      Main titles, use only once per page.
                    </div>
                  </b-td>
                  <b-td>
                    <div class="pb-2">
                      <strong>Basic properties</strong><br>
                      Font-size: 16px<br>
                      Font-weight: 400 / regular
                    </div>
                    <div class="pb-2">
                      <strong>UI properties</strong><br>
                      Line height: 18px<br>
                      Margin bottom: 8px
                    </div>
                    <div>
                      <strong>Use for</strong><br>
                      Main titles, use only once per page.
                    </div>
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-td><h6>h6</h6></b-td>
                  <b-td>
                    <div class="pb-2">
                      <strong>Basic properties</strong><br>
                      Font-size: 14px / 1rem<br>
                      Font-weight: 400 / regular
                    </div>
                    <div class="pb-2">
                      <strong>UI properties</strong><br>
                      Line height: 16.8px / 1.2<br>
                      Margin bottom: 7px / 0.5rem
                    </div>
                    <div>
                      <strong>Use for</strong><br>
                      Main titles, use only once per page.
                    </div>
                  </b-td>
                  <b-td>
                    <div class="pb-2">
                      <strong>Basic properties</strong><br>
                      Font-size: 14px<br>
                      Font-weight: 400 / regular
                    </div>
                    <div class="pb-2">
                      <strong>UI properties</strong><br>
                      Line height: 16px<br>
                      Margin bottom: 8px
                    </div>
                    <div>
                      <strong>Use for</strong><br>
                      Main titles, use only once per page.
                    </div>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-card no-body>
          <b-card-header>
            <b-card-title>Formatting</b-card-title>
          </b-card-header>
          <b-card-body class="pb-1">
            <b-table-simple
              hover
              caption
              responsive
            >
              <b-thead>
                <b-th>Style</b-th>
                <b-th>Size for static pages</b-th>
                <b-th>Size for dashboard pages</b-th>
                <b-th>Content</b-th>
              </b-thead>
              <b-tbody>
                <b-tr>
                  <b-td><strong>Bold</strong></b-td>
                  <b-td>14px</b-td>
                  <b-td>14px</b-td>
                  <b-td>Use <code>&#x3c;strong&#x3e;</code> to emphasize text.</b-td>
                </b-tr>
                <b-tr>
                  <b-td><em>Italics</em></b-td>
                  <b-td>14px</b-td>
                  <b-td>14px</b-td>
                  <b-td>Use <code>&#x3c;em&#x3e;</code> to italicize text.</b-td>
                </b-tr>
                <b-tr>
                  <b-td>Small</b-td>
                  <b-td>11px</b-td>
                  <b-td>14px</b-td>
                  <b-td>Use <code>&#x3c;small&#x3e;</code> primarily on help text under form fields, and as secondary supoorting text in applications. It should be used sparingly.</b-td>
                </b-tr>
                <b-tr>
                  <b-td><a>Link</a></b-td>
                  <b-td>14px</b-td>
                  <b-td>14px</b-td>
                  <b-td>Use when you are linking just a few words of text, or when a link is standalone. Do not use for actons, instead use a button. Links use color <code>#f9278e</code> and are not underlined except on hover.</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <!-- <b-row>
      <b-col>
        <b-card>
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
          >
            Code Guide
          </b-button>
        </b-card>
      </b-col>
    </b-row> -->
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BCardHeader, BCardTitle, BCardBody, BCardText, BTableSimple, BThead, BTr, BTh, BTbody, BTd,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BTableSimple,
    BCardHeader,
    BCardBody,
    BCardTitle,
    BCardText,
    BThead,
    BTr,
    BTh,
    BTbody,
    BTd,
  },
}
</script>

<style>
  .droid-font {
    font-family: 'Droid Sans', Helvetica, Arial, serif;
  }
  .heiti-font {
    font-family: 'adobe-heiti-std', sans-serif;
  }
  .sarabun-font {
    font-family: 'Sarabun', sans-serif;
  }
  .static-h1 {
    font-size: 56px;
  }
</style>
